import { render, staticRenderFns } from "./associatedImages.vue?vue&type=template&id=6d6c1fc0&scoped=true"
import script from "./associatedImages.vue?vue&type=script&lang=js"
export * from "./associatedImages.vue?vue&type=script&lang=js"
import style0 from "./associatedImages.vue?vue&type=style&index=0&id=6d6c1fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c1fc0",
  null
  
)

export default component.exports